module.exports = __webpack_public_path__ + "static/National-Book-0df5eb4d0f7b24bee4f95075a8476a2f.otf";